<template>
  <div class="login">
    <div v-if="quanxian" class="loginBox">
      <!-- 标题 -->
      <div class="title">
        {{ $t("login.login") }}
        <p class="loginBorder"></p>
      </div>
      <!-- 输入账号 -->
      <div class="ipt_box">
        <p class="icon_box">
          <i class="icon iconfont fs_18">&#xe66c;</i>
        </p>
        <input
          class="username"
          maxlength="16"
          :placeholder="$t('login.pleaseUsername')"
          type="text"
          v-model.trim="username"
        />
      </div>
      <!-- 输入密码 -->
      <div class="ipt_box">
        <p class="icon_box">
          <i class="icon iconfont fs_18">&#xe66d;</i>
        </p>
        <input
          class="password"
          maxlength="16"
          :type="isShowPassword ? 'text' : 'password'"
          :placeholder="$t('login.pleasePassword')"
          v-model.trim="password"
        />
        <p v-if="isShowPassword" class="icon_box pointer" @click="ShowPassword">
          <i class="icon iconfont fs_12">&#xe66f;</i>
        </p>
        <p
          v-if="!isShowPassword"
          class="icon_box pointer"
          @click="ShowPassword"
        >
          <i class="icon iconfont fs_12">&#xe66e;</i>
        </p>
      </div>
      <!-- 输入验证码 -->
      <div class="ipt_box">
        <input
          class="captcha"
          maxlength="4"
          type="text"
          v-model.trim="captcha"
          :placeholder="$t('login.pleaseKaptcha')"
          @keyup.enter="login"
        />
        <p class="captcha_img" @click="getKaptcha">
          <img :src="'data:image/png;base64,' + captchaSrc" alt />
        </p>
      </div>
      <!-- 登陆按钮 -->
      <Tbutton class="loginBtn" @click.native="login">{{
        $t("login.login")
      }}</Tbutton>
    </div>
    <div v-else class="noAuthority">
      <div class="tipsIcoBox">
        <img src="../../assets/images/common/tipsIco.png" class="tipsIco" />
      </div>
      <p class="tips">{{ $t("login.rongziwei") }}</p>
      <p class="hehe" style="display: none">
        · {{ $t("login.nianlilv") }}
        <br />
        · {{ $t("login.jiesheng") }}
        <br />
        · {{ $t("login.bushouxianzhi") }}
        <br />
        · {{ $t("login.xinyong") }}
      </p>
      <div class="telBox">
        <div class="telBg">
          <p>* {{ $t("login.fuwu") }} +65-63038896 (7x24h)</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixins from '@/helper/mixins.js';
import ContentBox from "../../components/ContentBox";
import Tbutton from "../../components/Tbutton";
import { mapState } from "vuex";
export default {
  name: "login",
  mixins: [mixins],
  components: {
    ContentBox,
    Tbutton
  },
  data() {
    return {
      isShowPassword: false,
      username: null,
      password: null,
      captcha: null,
      captchaSrc: null,
      captchaKey: null,
      quanxian: true
    };
  },
  computed: {
    ...mapState(["userProfile"]),
    userType() {
      return this.userProfile.type;
    },
    loanMenuList() {
      let { loanMenuList } = this.userProfile;
      return Array.isArray(loanMenuList) ? loanMenuList : [];
    }
  },
  methods: {
    // 显示或隐藏密码
    ShowPassword() {
      this.isShowPassword = !this.isShowPassword;
    },
    // 登陆
    login() {
      if(!this.username){
        this.$message.error(this.$t('login.pleaseUsername'));
        return false;
      }
      if(!this.password){
        this.$message.error(this.$t('login.inputPwd'));
        return false;
      }
      if(!this.captcha){
        this.$message.error(this.$t('login.inputCode'));
        return false;
      }
      this.axios
        .post("/api/zma/login", {
          code: this.captcha,
          loginName: this.username,
          password: this.password,
          captchaKey: this.captchaKey
          // type: 0
        })
        .then(res => {
          if (res.status) {
            this.$store.commit("SAVE_USER_INFO", res.data);
            if (this.findRight(6) || res.data.isSuper) {
              this.$router.push("/allorders"); // 全部订单
            } else if (this.findRight(1)) {
              this.$router.push("/newriskmanage");
            } else if (this.findRight(2)) {
              this.$router.push("/financingFundList");
            } else if (this.findRight(3)) {
              this.$router.push("/financingExamineList");
            } else if (this.findRight(4)) {
              this.$router.push("/afterLoanList");
            } else if (this.findRight(5)) {
              this.$router.push("/poolofmoney");
            } else {
              this.quanxian = false;
            }
          } else {
            if (res.errorCode === "loan_audit_50000029") {
              this.quanxian = false;
            }
            this.$message.error(this.$t(`error.${res.errorCode}`));
            this.getKaptcha();
          }
        });
    },
    // 获取验证码
    getKaptcha() {
      this.axios.get("/captcha").then(res => {
        if (res.status) {
          this.captchaKey = res.data.captchaKey;
          this.captchaSrc = res.data.imgSrc;
        } else {
          this.$message.error(this.$t(`error.${res.errorCode}`));
        }
      });
    },
    findRight(menuType) {
      let arr = this.loanMenuList.filter(item => item.menuType === menuType);
      return Array.isArray(arr) && arr.length
        ? arr.some(lts => lts.optType === 1)
        : false;
    }
  },
  created() {
    // document.title = this.$t("login.login")
    this.getKaptcha();
  },
  mounted() {
    // console.log(this.userProfile.menuLimit);
    document.title = this.$t("login.login");
  }
};
</script>

<style lang="scss" scoped>
.login {
  width: 1200px;
  height: 450px;
  background: #ffffff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  .loginBox {
    width: 400px;
    margin: 0 auto;
    .title {
      margin-top: 32px;
      font-size: 24px;
      color: #333333;
      letter-spacing: 0;
      display: inline-block;
      .loginBorder {
        margin: 8px 0;
        height: 4px;
        background: #7996f5;
        border-radius: 2px;
      }
    }

    .ipt_box {
      width: 400px;
      height: 50px;
      border: 1px solid #e4e8ef;
      border-radius: 2px;
      margin-top: 24px;
      input {
        border: none;
      }
      .icon_box {
        float: left;
        width: 50px;
        height: 50px;
        line-height: 50px;
        text-align: center;
      }
      .username,
      .password {
        float: left;
        width: 300px;
        height: 48px;
      }
      .username {
        width: 348px;
        background: none;
      }
      .captcha {
        float: left;
        width: 275px;
        height: 48px;
        padding-left: 10px;
        background: none;
      }
      .captcha_img {
        float: left;
      }
      .captcha_img img {
        width: 110px;
        margin-top: 7px;
        height: 36px;
      }
    }
    .loginBtn {
      margin-top: 24px;
      width: 170px;
      height: 50px;
    }
  }

  .noAuthority {
    position: relative;
    width: 860px;
    height: 450px;
    margin: 0 auto;
    .tipsIcoBox {
      padding: 20px 0;
      .tipsIco {
        display: block;
        margin: 0 auto;
      }
    }
    .tips {
      font-size: 18px;
      color: #333333;
      text-align: center;
    }
    .hehe {
      padding: 20px;
      text-align: center;
      font-size: 14px;
      color: #81899e;
    }
    .telBox {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 70px;
      padding: 15px 0;
      box-shadow: inset 0 1px 0 0 #eaeaea;
      .telBg {
        position: relative;
        width: 570px;
        height: 70px;
        text-align: center;
        font-size: 14px;
        color: #7996f5;
        margin: 0 auto;
        background: #d9e2fe;
        border-radius: 4px;
        overflow: hidden;
        p {
          position: absolute;
          width: 550px;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
  }
}
</style>
